import * as React from "react";
import s from "./index.module.scss";
import * as Assets from "../../assets";

const InfoControl = () => {
	const [isOpen, setIsOpen] = React.useState<boolean>(false);

	const onClickInfo = (event: any) => {
		!event.preventDefault && event.preventDefault();
		setIsOpen(!isOpen);
	};

	return (
		<div className={s.InfoControl}>
			<div className={s.InfoControl__button} onClick={onClickInfo}>
				<img alt={"info"} src={Assets.Info}/>
			</div>
			{isOpen && (<div className={s.InfoControl__info}>
				<div className={s.InfoControl__info__row}><div className={[s.InfoControl__info__pin, s.InfoControl__info_black].join(" ")}/>Shipment not started</div>
				<div className={s.InfoControl__info__row}><div className={[s.InfoControl__info__pin, s.InfoControl__info_blue].join(" ")}/>Shipment data received,<br/>no alarms</div>
				<div className={s.InfoControl__info__row}><div className={[s.InfoControl__info__pin, s.InfoControl__info_yellow].join(" ")}/>Shipment data not received,<br/>no alarms</div>
				<div className={s.InfoControl__info__row}><div className={[s.InfoControl__info__pin, s.InfoControl__info_red].join(" ")}/>Active Alarms,<br/>shipment data not received</div>
			</div>)}
		</div>
	);
};

export default InfoControl;
